<template>
  <div>
    <SearchBar></SearchBar>
    <!-- <ImageSlider v-if="showSlider"></ImageSlider> -->
    <CategoryList></CategoryList>
  </div>
</template>
<script type="text/javascript">
import ImageSlider from './ImageSlider'
import CategoryList from './CategoryList'
import SearchBar from './SearchBar'
import {
  FITFormCard,
  FITCheckbox,
  FITSelect,
  FITTextInput,
  FITInputTag,
  FITButton,

} from '@/components'
import { mapGetters } from 'vuex'

export default {
  name: 'MPHeader',
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    ImageSlider,
    CategoryList,
    SearchBar


  },
  props: {
    // showSlider:{
    //   type:Boolean,
    //   default:true,
    // },
    VuexModule:{
      type:String,
      default:'',
    }
  },
  data() {
    return {

    }
  },
  created() {
                this.$store.dispatch('Shop/getCategoryList');
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}

</script>
<style type="text/css">
/*.weui-search-bar__cancel-btn{
  display: none !important;
}*/

</style>



// WEBPACK FOOTER //
// src/components/Header/MPHeader.vue